<template>
  <div class="new-version-event">
    <div class="event-subject">
      <div class="event-title">
        <vs-icon class="mr-2"
                 color="success"
                 icon="icon-package"
                 icon-pack="feather"/>
        <span class="text-success">{{ event.subject }}</span>
      </div>

      <div class="event-time mt-1 text-xs">
        {{ $u.convertUtcToLocale(event.created_at, $u.locale.validator('moment.dateTime')) }}
      </div>
    </div>

    <div class="u-divider mt-2 mb-5"/>

    <div class="event-content">
      <vue-markdown>{{ event.content }}</vue-markdown>

      <button class="accept-button bg-success"
              @click="$emit('seen')">
        {{ $t('pages.events.event.labels.understand') }}
      </button>
    </div>
  </div>
</template>

<script>
import vueMarkdown from 'vue-markdown'

export default {
  name: 'newVersionEvent',
  components: {vueMarkdown},
  props: {
    event: {
      type: Object,
      default: () => { return {} }
    }
  }
}
</script>

<style lang="scss">
.new-version-event {
  padding: 1.5rem;
  height: 100%;
  position: relative;

  img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 10rem;
    margin: auto;
  }

  .event-subject {
    font-weight: 500;
    font-size: 1.7rem;
  }

  .event-content {
    margin-top: 1rem;

    button.accept-button {
      display: block;
      cursor: pointer;
      padding: 1rem 2.5rem;
      color: #ffffff;
      //background: #77c533;
      border-radius: 3rem;
      border: none;
      margin: 1rem auto 0;
      transition: all .3s ease;
      box-shadow: 0 0 0 rgba(var(--vs-success), 1);

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 0 0.5rem rgba(var(--vs-success), 1);
      }
    }

    ul {
      padding: 1rem 2rem !important;

      li {
        list-style: disc;
      }
    }
  }
}
</style>
